import type { z } from 'zod';

import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { CallOffForm } from '~/modules/callOff/form';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import {
  routeParams,
  zodCreateCallOffSearchParamsSchema,
} from '../-routeParams';

type CreateCallOffSearchParams = z.infer<
  typeof zodCreateCallOffSearchParamsSchema
>;

const defaultSearchParams: CreateCallOffSearchParams = {
  duplicateCallOffId: undefined,
};

const title = i18n.t(($) => $.form.pageTitle.create, { ns: 'callOff' });

export const Route = createFileRoute('/(main)/demand/call-offs/create/')({
  beforeLoad: createProtectedRoute({
    routePath: '/demand/call-offs/create',
    ...routeParams,
  }),
  component: CallOffForm,
  head: () => getRouteHead(title, 'Erstelle einen neuen Abruf in VESTIGAS'),
  search: {
    middlewares: [stripSearchParams(defaultSearchParams)],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: zodCreateCallOffSearchParamsSchema,
});

export const DEMAND_CALLOFF_CREATE = buildRouteExport({
  Route,
  ...routeParams,
});
